import { DateRangePickerValue, PredefinedDateGroupId } from "../types"
import { IsoDate } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/types"
import { format } from "date-fns"
import { getPredefinedDateGroups } from "../utils"
import { classNames } from "../../../../utils/classNames"
import { useMemo } from "react"
import { WeekStartDay } from "../../../screens/settings/types"

type Props = {
    maxRange?: number
    weekStartDay: WeekStartDay
    value: DateRangePickerValue
    onChange: (value: DateRangePickerValue) => void
    onHover: (value: DateRangePickerValue | null) => void
}
export const PredefinedDates = (props: Props) => {
    const today = format(new Date(), "yyyy-MM-dd") as IsoDate
    const predefinedDates = useMemo(
        () => getPredefinedDateGroups(today, props.maxRange, props.weekStartDay),
        [today, props.maxRange, props.weekStartDay]
    )

    const onMouseEnter = (value: DateRangePickerValue) => {
        props.onHover(value)
    }
    const onMouseLeave = () => {
        props.onHover(null)
    }

    return (
        <div className={classes.container}>
            {predefinedDates.map(group => {
                if (group.groupId === PredefinedDateGroupId.Main) {
                    return (
                        <div key={group.groupId} className={classes.mainGroup}>
                            {group.dates.map(date => {
                                const isActive =
                                    date.value.start === props.value.start && date.value.end === props.value.end
                                return (
                                    <button
                                        className={classNames(
                                            classes.mainDateButton,
                                            isActive && classes.mainDateButtonActive
                                        )}
                                        key={date.label}
                                        type="button"
                                        onMouseEnter={() => onMouseEnter(date.value)}
                                        onMouseLeave={onMouseLeave}
                                        onClick={() => {
                                            props.onChange(date.value)
                                        }}>
                                        {date.icon ? <div className={classes.iconWrapper}>{date.icon}</div> : null}
                                        <div>{date.label}</div>
                                    </button>
                                )
                            })}
                        </div>
                    )
                }
                return (
                    <div key={group.groupId}>
                        <h3 className={classes.groupLabel}>{group.groupLabel}</h3>
                        {group.dates.map(date => {
                            const isActive =
                                date.value.start === props.value.start && date.value.end === props.value.end
                            return (
                                <button
                                    key={date.label}
                                    type="button"
                                    className={classNames(classes.dateButton, isActive && classes.dateButtonActive)}
                                    onMouseEnter={() => onMouseEnter(date.value)}
                                    onMouseLeave={onMouseLeave}
                                    onClick={() => {
                                        props.onChange(date.value)
                                    }}>
                                    {date.label}
                                </button>
                            )
                        })}
                    </div>
                )
            })}
        </div>
    )
}

const classes = {
    container: "w-full max-w-[150px] space-y-2",
    mainGroup: "pb-1 space-y-1",
    mainDateButton:
        "text-left w-full flex items-center text-[14px] text-black/90 bg-transparent py-[8px] px-4 leading-none rounded-[4px] border border-gray-300 m-0 cursor-pointer hover:border-primary-color hover:text-primary-color transition",
    mainDateButtonActive: "bg-primary-color/10 border-primary-color text-primary-color",
    iconWrapper: "mr-1.5 -mb-px",
    groupLabel: "text-[14px] text-black/50 m-0",
    dateButton:
        "text-left w-full text-[14px] text-black/80 bg-transparent py-2 px-4 leading-none rounded-[4px] m-0 cursor-pointer hover:border-primary-color hover:text-primary-color transition",
    dateButtonActive: "bg-primary-color/10 border-primary-color text-primary-color",
}
